const articleData = [
  {
    id: 1,
    img: "https://placehold.co/800x400?text=Laptop+Recommendations",
    alt: "A sleek laptop on a modern desk",
    title: "HOW TO CHOOSE THE PERFECT LAPTOP FOR YOUR NEEDS",
    text: "Choosing the perfect laptop can be a daunting task with so many options available. This guide will help you navigate through specifications, performance, and design to find the ideal laptop for your needs, whether for work, gaming, or everyday use.",
    highlight:
      "Invest in a laptop that matches your lifestyle and boosts your productivity.",
    text2:
      "When selecting a laptop, consider factors such as processing power, RAM, storage options, and display quality. Think about whether portability or performance is your priority. Additionally, explore features like battery life and build quality to ensure your laptop suits your daily tasks. Make an informed decision and get the best value for your money.",
  },
  {
    id: 2,
    img: "https://placehold.co/800x400?text=Build+Your+Own+PC",
    alt: "Custom-built PC setup with RGB lighting",
    title: "BUILDING YOUR OWN PC: A BEGINNER'S GUIDE",
    text: "Building your own PC can be a fulfilling experience and a cost-effective way to get the exact specifications you need. This article breaks down the process, from selecting components to assembling and troubleshooting your custom rig.",
    highlight: "Create a PC that reflects your needs and personality.",
    text2:
      "Begin by identifying the purpose of your PC—gaming, productivity, or multimedia. Choose compatible components like CPU, GPU, RAM, and storage. Follow step-by-step instructions to assemble and configure your system. Building your own PC gives you the flexibility to upgrade and customize as needed.",
  },
  {
    id: 3,
    img: "https://placehold.co/800x400?text=Top+Gaming+Accessories",
    alt: "Gaming setup with high-end accessories",
    title: "TOP GAMING ACCESSORIES FOR THE ULTIMATE EXPERIENCE",
    text: "Elevate your gaming experience with the best accessories. From ergonomic keyboards to immersive headsets, discover the gear that can enhance your performance and comfort during long gaming sessions.",
    highlight: "Equip yourself with the tools to conquer your gaming goals.",
    text2:
      "Explore top gaming accessories like mechanical keyboards, high-DPI gaming mice, and surround sound headsets. Add RGB lighting for aesthetics and cooling pads for performance. Optimize your setup for peak gaming performance and enjoyment.",
  },
  {
    id: 4,
    img: "https://placehold.co/800x400?text=Desktop+vs+Laptop",
    alt: "A desktop and laptop side by side",
    title: "DESKTOP VS LAPTOP: WHICH IS RIGHT FOR YOU?",
    text: "Deciding between a desktop and a laptop depends on your lifestyle and requirements. This article compares the advantages and disadvantages of each to help you make the right choice for gaming, work, or portability.",
    highlight: "Find the perfect device for your specific needs.",
    text2:
      "Desktops offer superior performance and customization, ideal for gaming and high-end tasks. Laptops provide portability and convenience for on-the-go productivity. Understand your priorities and choose the device that aligns with your workflow.",
  },
  {
    id: 5,
    img: "https://placehold.co/800x400?text=Upgrade+to+SSD",
    alt: "SSD drives on a table",
    title: "WHY YOU SHOULD UPGRADE TO AN SSD",
    text: "Upgrading to a solid-state drive (SSD) can dramatically improve your computer's performance. This article explains the benefits of SSDs, including faster boot times, quicker file transfers, and enhanced system responsiveness.",
    highlight: "Experience the speed and reliability of modern storage.",
    text2:
      "Replace your traditional hard drive with an SSD to enjoy significantly faster speeds and durability. SSDs are ideal for both personal and professional use, providing a seamless computing experience. Learn how to upgrade and maximize your system's potential.",
  },
  {
    id: 6,
    img: "https://placehold.co/800x400?text=Smart+Home+Tech",
    alt: "Smart home devices on display",
    title: "SMART HOME TECH: WHERE TO START",
    text: "Transform your living space with smart home technology. From smart speakers to security systems, this guide introduces the essential devices to begin your journey into home automation.",
    highlight:
      "Upgrade your home with smart technology for convenience and security.",
    text2:
      "Start small with smart plugs, lights, or thermostats. Gradually expand to include security cameras, doorbells, and integrated voice assistants. Discover how smart technology can make your home safer, more energy-efficient, and easier to manage.",
  },
];

export default articleData;
